import { createReducer, on } from '@ngrx/store';
import { initialEquipmentProjectState, EquipmentProjectState } from './equipment-project.state';
import {
  loadEquipmentProjectsByProject,
  loadEquipmentProjectsByProjectSuccess,
  loadEquipmentProjectsByProjectFailure,
  addEquipmentProjects,
  addEquipmentProjectsSuccess,
  addEquipmentProjectsFailure,
  updateEquipmentProject,
  updateEquipmentProjectSuccess,
  updateEquipmentProjectFailure,
  deleteEquipmentProject,
  deleteEquipmentProjectSuccess,
  deleteEquipmentProjectFailure,
} from './equipment-project.actions';

export const equipmentProjectReducer = createReducer(
  initialEquipmentProjectState,

  on(loadEquipmentProjectsByProject, (state): EquipmentProjectState => ({
    ...state, loading: true, error: null,
  })),
  on(loadEquipmentProjectsByProjectSuccess, (state, { items, projectId }): EquipmentProjectState => ({
    ...state, items, loadedProjectId: projectId, loading: false,
  })),
  on(loadEquipmentProjectsByProjectFailure, (state, { error }): EquipmentProjectState => ({
    ...state, error, loading: false,
  })),

  on(addEquipmentProjects, (state): EquipmentProjectState => ({
    ...state, saving: true, error: null,
  })),
  on(addEquipmentProjectsSuccess, (state, { items }): EquipmentProjectState => ({
    ...state, items: [...state.items, ...items], saving: false,
  })),
  on(addEquipmentProjectsFailure, (state, { error }): EquipmentProjectState => ({
    ...state, error, saving: false,
  })),

  on(updateEquipmentProject, (state): EquipmentProjectState => ({
    ...state, saving: true, error: null,
  })),
  on(updateEquipmentProjectSuccess, (state, { item }): EquipmentProjectState => ({
    ...state,
    saving: false,
    items: state.items.map(i => i.equipmentProjectId === item.equipmentProjectId ? item : i),
  })),
  on(updateEquipmentProjectFailure, (state, { error }): EquipmentProjectState => ({
    ...state, error, saving: false,
  })),

  on(deleteEquipmentProject, (state): EquipmentProjectState => ({
    ...state, saving: true, error: null,
  })),
  on(deleteEquipmentProjectSuccess, (state, { id }): EquipmentProjectState => ({
    ...state,
    saving: false,
    items: state.items.filter(i => i.equipmentProjectId !== id),
  })),
  on(deleteEquipmentProjectFailure, (state, { error }): EquipmentProjectState => ({
    ...state, error, saving: false,
  })),
);
